import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  pageRoot: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    minHeight: 0,
    overflow: "hidden",
  },
  contentScroll: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    overflowX: "auto",
    paddingBottom: theme.spacing(2),
  },
  contentLock: {
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    paddingBottom: 0,
  },
  settingsShell: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    minWidth: 0,
  },
  settingsTabs: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider || (theme.mode === "dark" ? "#374151" : "#e0e0e0")}`,
    position: "sticky",
    top: 0,
    zIndex: 2,
    "& .MuiTabs-root": { minHeight: 48 },
    "& .MuiTab-root": {
      textTransform: "none",
      fontWeight: 650,
      minWidth: 112,
      minHeight: 48,
      fontSize: 14,
    },
    [theme.breakpoints.down("sm")]: {
      position: "static",
      "& .MuiTab-root": { minWidth: 96, fontSize: 13, padding: "8px 12px" },
    },
  },
  settingsPanel: {
    flex: 1,
    minWidth: 0,
  },
  storeSettings: {
    minWidth: 0,
    maxWidth: "100%",
    overflowWrap: "anywhere",
    "& .store-form": { display: "grid", gap: 14, maxWidth: 760, minWidth: 0 },
    "& .store-actions": { display: "flex", flexWrap: "wrap", gap: 10 },
    "& .store-split": { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, minWidth: 0 },
    "& .store-orders-cards": { display: "none" },
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "calc(88px + env(safe-area-inset-bottom, 0px))",
      "& .MuiInputBase-input, & .MuiInputBase-inputMultiline": { fontSize: 16 },
      "& .store-actions": { display: "grid", gridTemplateColumns: "1fr", gap: 8 },
      "& .store-actions .MuiButton-root": { width: "100%" },
      "& .store-sticky": {
        position: "fixed",
        left: 12,
        right: 12,
        bottom: "calc(96px + env(safe-area-inset-bottom, 0px))",
        zIndex: theme.zIndex.appBar,
        margin: 0,
        padding: "10px 12px",
        borderRadius: 16,
        background: theme.palette.background.paper,
        boxShadow: "0 8px 24px rgba(15,23,42,.16)",
      },
      "& .store-split": { flexDirection: "column", alignItems: "stretch" },
      "& .store-split .MuiButton-root": { alignSelf: "stretch" },
      "& .store-orders-table": { display: "none" },
      "& .store-orders-cards": { display: "grid", gap: 10 },
      "& .store-order-card": {
        display: "grid",
        gap: 6,
        border: "1px solid #e3e0ee",
        borderRadius: 12,
        padding: 12,
      },
    },
  },
  listPane: {
    flex: 1,
    minHeight: 0,
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
  },
  tableWrapFill: {
    flex: 1,
    minHeight: 0,
    maxHeight: "none",
  },
  cartDetailIdentity: {
    width: "100%",
    alignItems: "flex-start",
    "& > div:last-child": { flex: 1, minWidth: 0 },
  },
  cartDetailMetrics: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 14,
    marginTop: 6,
    "& strong": { fontSize: 13, fontWeight: 800 },
  },
  cardMetrics: {
    display: "flex",
    alignItems: "center",
    gap: 18,
    flexWrap: "wrap",
    marginTop: 4,
    [theme.breakpoints.down("sm")]: {
      display: "grid",
      gridTemplateColumns: "minmax(0, 1.2fr) auto minmax(0, 1fr)",
      gap: 8,
      marginTop: 0,
      fontSize: 12,
      minWidth: 0,
      "& > *": { minWidth: 0, overflowWrap: "anywhere" },
    },
  },
  cellEllipsis: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    minWidth: 0,
  },
  customerCardActions: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    width: "100%",
    marginTop: 8,
    paddingTop: 6,
    borderTop: `1px solid ${theme.palette.divider}`,
    "& .MuiIconButton-root": { minWidth: 44, minHeight: 44, padding: 10 },
  },
  cardInlineActions: {
    marginLeft: "auto",
    flexShrink: 0,
    "& .MuiIconButton-root": {
      padding: 6,
    },
  },
  selectRow: {
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
    gap: 8,
    minWidth: 0,
    maxWidth: "100%",
    overflowX: "auto",
    overflowY: "hidden",
    paddingTop: 6,
    marginTop: -6,
    WebkitOverflowScrolling: "touch",
    ...theme.hiddenScrollbar,
    "& > *": {
      flexShrink: 0,
    },
  },
  phoneInline: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    flexWrap: "wrap",
    minWidth: 0,
  },
  phoneWithFlag: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    minWidth: 0,
    fontWeight: 700,
  },
  phoneFields: {
    display: "flex",
    alignItems: "flex-start",
    gap: 8,
    width: "100%",
  },
  phonePrefixField: {
    width: 148,
    flexShrink: 0,
  },
  phoneLocalField: {
    flex: 1,
    minWidth: 0,
  },
  phonePrefixValue: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
  },
  typeChoiceLabel: {
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: 0.4,
    textTransform: "uppercase",
    color: theme.palette.text.secondary,
    margin: "4px 0 6px",
  },
  typeChoiceRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    marginBottom: 12,
  },
  typeChoice: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "8px 14px",
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
    background: theme.palette.background.paper,
    cursor: "pointer",
    fontWeight: 800,
    fontSize: 13,
    color: theme.palette.text.primary,
    appearance: "none",
    WebkitAppearance: "none",
    fontFamily: "inherit",
    "& svg": { fontSize: 18 },
  },
  typeChoiceOn: {
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
    backgroundColor: theme.mode === "dark" ? "rgba(14,165,233,0.12)" : "#e0f2fe",
    boxShadow: `0 0 0 1px ${theme.palette.primary.main}`,
  },
  importHint: {
    borderRadius: 12,
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
    backgroundColor: theme.mode === "dark" ? "rgba(14,165,233,0.12)" : "#e0f2fe",
    color: theme.palette.text.primary,
    fontSize: 13,
    lineHeight: 1.45,
    "& code": {
      display: "block",
      margin: "6px 0 10px",
      fontSize: 12,
      whiteSpace: "pre-wrap",
      fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
    },
    "& ul": {
      margin: 0,
      paddingLeft: 18,
    },
  },
  importDrop: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    border: `1px dashed ${theme.palette.divider}`,
    borderRadius: 12,
    padding: theme.spacing(2),
    textAlign: "center",
    cursor: "pointer",
    backgroundColor: theme.mode === "dark" ? "rgba(15,23,42,0.35)" : "#f8fafc",
  },
  captionInline: {
    color: theme.palette.text.secondary,
    fontSize: 13,
    fontWeight: 600,
  },
  trafficStatus: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    fontWeight: 700,
    whiteSpace: "nowrap",
  },
  accountMark: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    minWidth: 0,
    maxWidth: "100%",
  },
  accountMarkEmail: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    minWidth: 0,
  },
  accountOptionMeta: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    flexShrink: 0,
    color: theme.palette.text.secondary,
    fontSize: 13,
    fontWeight: 600,
    whiteSpace: "nowrap",
  },
  typePickRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    margin: "2px 0 12px",
  },
  typePick: {
    border: "2px solid transparent",
    cursor: "pointer",
    background: "none",
    appearance: "none",
    WebkitAppearance: "none",
  },
  typePickOn: {
    boxShadow: `0 0 0 2px ${theme.palette.primary.main}`,
  },
  cartDialogTitle: {
    padding: "8px 56px 4px 16px !important",
  },
  cartCodeLine: {
    display: "flex",
    flexWrap: "wrap",
    gap: "4px 14px",
    marginTop: 4,
    fontSize: 13,
    color: theme.palette.text.secondary,
  },
  previewNote: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    marginBottom: theme.spacing(2),
    padding: "6px 12px",
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 700,
    color: theme.palette.primary.main,
    backgroundColor: theme.mode === "dark" ? "rgba(14,165,233,0.16)" : "#e0f2fe",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1.5),
    flexWrap: "wrap",
    flexShrink: 0,
    minWidth: 0,
    marginBottom: theme.spacing(1.5),
    [theme.breakpoints.down("sm")]: {
      gap: theme.spacing(1),
      flexDirection: "column",
      alignItems: "stretch",
      "& .MuiButton-root": {
        flex: "1 1 auto",
      },
      "& $filters, & $filterRow, & $filterBar": {
        width: "100%",
        maxWidth: "100%",
      },
    },
  },
  filters: {
    display: "flex",
    flexWrap: "nowrap",
    gap: 6,
    overflowX: "auto",
    overflowY: "hidden",
    alignItems: "center",
    minWidth: 0,
    maxWidth: "100%",
    WebkitOverflowScrolling: "touch",
    ...theme.hiddenScrollbar,
    "& > *": {
      flexShrink: 0,
    },
  },
  filterBar: {
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
    gap: 8,
    flexShrink: 0,
    minWidth: 0,
    maxWidth: "100%",
    overflowX: "auto",
    overflowY: "hidden",
    WebkitOverflowScrolling: "touch",
    marginBottom: theme.spacing(1),
    ...theme.hiddenScrollbar,
    "& $filters": {
      overflow: "visible",
      flexWrap: "nowrap",
      flex: "0 0 auto",
      maxWidth: "none",
    },
    "& > *": {
      flexShrink: 0,
    },
    [theme.breakpoints.down("sm")]: {
      gap: 6,
    },
  },
  "@keyframes serviceCardEnter": {
    from: { opacity: 0, transform: "translateY(6px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  serviceCustomerCard: {
    margin: 8,
    border: `1px solid ${theme.palette.divider}`,
    borderLeft: `3px solid ${theme.palette.primary.main}`,
    borderRadius: 12,
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0 2px 8px rgba(15,23,42,0.04)",
    animation: "$serviceCardEnter 220ms ease-out backwards",
    transition: "box-shadow 160ms ease, border-color 160ms ease, transform 160ms ease",
    "&:focus-visible": { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 2 },
    "@media (hover: hover)": {
      "&:hover": { transform: "translateY(-2px)", borderColor: theme.palette.primary.main, boxShadow: "0 5px 16px rgba(15,23,42,0.10)" },
    },
    "@media (prefers-reduced-motion: reduce)": {
      animation: "none", transition: "none", "&:hover": { transform: "none" },
    },
  },
  serviceCardActions: {
    display: "flex",
    alignItems: "center",
    flexWrap: "nowrap",
    flexShrink: 0,
    gap: 2,
    "& > *": { flexShrink: 0 },
    "& $collectActions": {
      width: "auto", flexWrap: "nowrap", flexShrink: 0,
      justifyContent: "flex-start", whiteSpace: "nowrap",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%", minWidth: 0, overflowX: "auto", overflowY: "hidden",
      WebkitOverflowScrolling: "touch",
      borderTop: `1px solid ${theme.palette.divider}`,
      paddingTop: 6,
      "& .MuiIconButton-root": { minWidth: 44, minHeight: 44, padding: 10 },
    },
  },
  collectRow: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: 12,
    minWidth: 0,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
      gap: 10,
      padding: "12px 12px 10px",
    },
  },
  collectIdentity: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    flex: 1,
    minWidth: 0,
  },
  collectMarks: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    flexWrap: "wrap",
    marginRight: 10,
    maxWidth: 220,
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
      maxWidth: "100%",
    },
  },
  collectAmount: {
    textAlign: "right",
    marginRight: 8,
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
      textAlign: "left",
      marginRight: 0,
    },
  },
  collectMetaRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap",
    justifyContent: "space-between",
    minWidth: 0,
  },
  collectActions: {
    display: "inline-flex",
    alignItems: "center",
    flexShrink: 0,
    whiteSpace: "nowrap",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      justifyContent: "flex-end",
      whiteSpace: "normal",
      flexWrap: "wrap",
      gap: 2,
      "& .MuiIconButton-root": {
        padding: 10,
        minWidth: 44,
        minHeight: 44,
      },
    },
  },
  cartMobileList: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },
  cartMobileItem: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    padding: "10px 4px 12px",
    borderBottom: `1px solid ${theme.palette.divider}`,
    minWidth: 0,
    "&:last-child": {
      borderBottom: "none",
    },
  },
  cartMobileTop: {
    display: "flex",
    alignItems: "flex-start",
    gap: 10,
    minWidth: 0,
  },
  cartMobileBody: {
    flex: 1,
    minWidth: 0,
  },
  cartMobileActions: {
    display: "flex",
    justifyContent: "flex-end",
    flexWrap: "wrap",
    gap: 2,
    "& .MuiIconButton-root": {
      padding: 10,
      minWidth: 44,
      minHeight: 44,
    },
  },
  filterRow: {
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
    gap: 10,
    minWidth: 0,
    maxWidth: "100%",
    overflowX: "auto",
    overflowY: "hidden",
    WebkitOverflowScrolling: "touch",
    flex: 1,
    ...theme.hiddenScrollbar,
    "& $filters": {
      overflow: "visible",
      flex: "0 0 auto",
      maxWidth: "none",
    },
    "& > *": {
      flexShrink: 0,
    },
  },
  filterSplit: {
    width: 1,
    alignSelf: "stretch",
    minHeight: 22,
    backgroundColor: theme.palette.divider,
    flexShrink: 0,
  },
  pager: {
    display: "flex",
    justifyContent: "flex-end",
    borderTop: `1px solid ${theme.palette.divider}`,
    overflowX: "auto",
    position: "sticky",
    bottom: 0,
    zIndex: 4,
    flexShrink: 0,
    backgroundColor: theme.palette.background.paper,
    "& .MuiTablePagination-toolbar": {
      minHeight: 48,
      paddingLeft: 8,
    },
    "& .MuiTablePagination-selectRoot": {
      marginRight: 8,
    },
  },
  searchField: {
    minWidth: 200,
    maxWidth: 280,
    flexShrink: 0,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 10,
    [theme.breakpoints.down("sm")]: {
      minWidth: 0,
      width: "100%",
      maxWidth: "100%",
    },
  },
  searchFull: {
    maxWidth: "100%",
    width: "100%",
    marginBottom: theme.spacing(1.5),
  },
  kpiStrip: {
    display: "flex",
    flexWrap: "nowrap",
    gap: 8,
    overflowX: "auto",
    overflowY: "hidden",
    WebkitOverflowScrolling: "touch",
    marginBottom: theme.spacing(1.5),
    flexShrink: 0,
    minWidth: 0,
    maxWidth: "100%",
    ...theme.hiddenScrollbar,
    "& > *": {
      flex: "1 1 0",
      minWidth: 0,
    },
    [theme.breakpoints.down("sm")]: {
      "& > *": {
        flex: "1 0 148px",
        minWidth: 148,
      },
    },
  },
  kpiStripItem: {
    flex: "1 1 0",
    minWidth: 0,
    padding: "8px 12px",
    borderRadius: 10,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    gap: 2,
    [theme.breakpoints.down("sm")]: {
      minWidth: 0,
      padding: "6px 8px",
    },
  },
  kpiStripLabel: {
    fontSize: 11,
    fontWeight: 700,
    color: theme.palette.text.secondary,
    whiteSpace: "nowrap",
  },
  kpiStripValue: {
    fontSize: 16,
    fontWeight: 800,
    lineHeight: 1.25,
    whiteSpace: "nowrap",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    [theme.breakpoints.down("sm")]: {
      fontSize: 13,
      whiteSpace: "normal",
      overflow: "visible",
      textOverflow: "clip",
      wordBreak: "break-word",
      lineHeight: 1.2,
    },
  },
  chartGrid: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1.4fr) minmax(0, 1fr)",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
      gap: theme.spacing(1.5),
    },
  },
  chartCard: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 12,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    minHeight: 300,
    boxShadow: theme.mode === "dark" ? "none" : "0 1px 2px rgba(15,23,42,0.04)",
    overflow: "hidden",
    "& .recharts-brush-slide": {
      fill: theme.palette.primary.main,
      fillOpacity: 0.14,
    },
    "& .recharts-brush-traveller rect": {
      fill: theme.palette.primary.main,
      stroke: theme.palette.primary.main,
    },
    [theme.breakpoints.down("sm")]: {
      minHeight: 240,
      padding: theme.spacing(1.5),
    },
  },
  chartWide: {
    gridColumn: "1 / -1",
    minHeight: 0,
  },
  chartScroll: {
    maxHeight: 280,
    overflowY: "auto",
    overflowX: "hidden",
    minWidth: 0,
    paddingRight: 4,
    [theme.breakpoints.down("sm")]: {
      maxHeight: 240,
    },
  },
  chartProductBody: {
    display: "grid",
    gridTemplateColumns: "minmax(140px, 42%) minmax(0, 1fr)",
    gap: theme.spacing(1),
    alignItems: "center",
    minHeight: 220,
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
      minHeight: 0,
    },
  },
  chartRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.25),
    padding: "5px 6px",
    borderRadius: 8,
    cursor: "pointer",
    minWidth: 0,
    "&:hover": {
      backgroundColor: theme.mode === "dark" ? "rgba(148,163,184,0.12)" : "#f8fafc",
    },
  },
  chartRowOn: {
    backgroundColor: theme.mode === "dark" ? "rgba(91,91,240,0.16)" : "#eef2ff",
  },
  chartSwatch: {
    width: 10,
    height: 10,
    borderRadius: 3,
    flexShrink: 0,
  },
  chartHint: {
    fontSize: 11,
    color: theme.palette.text.secondary,
    margin: "0 0 10px",
  },
  chartMetaValue: {
    fontSize: 14,
    fontWeight: 700,
    color: theme.palette.text.primary,
    marginTop: 2,
  },
  kpiGrid: {
    display: "flex",
    flexWrap: "nowrap",
    gap: 8,
    marginBottom: theme.spacing(1.5),
    flexShrink: 0,
    minWidth: 0,
    maxWidth: "100%",
    overflowX: "auto",
    overflowY: "hidden",
    WebkitOverflowScrolling: "touch",
    ...theme.hiddenScrollbar,
    "& > *": {
      flex: "1 1 0",
      minWidth: 0,
    },
    [theme.breakpoints.down("sm")]: {
      gap: 6,
      marginBottom: theme.spacing(1),
      "& > *": {
        flex: "1 0 148px",
        minWidth: 148,
      },
    },
  },
  kpiCard: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 12px",
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    cursor: "default",
    minWidth: 0,
    transition: "box-shadow 0.15s ease, transform 0.15s ease",
    "&[role='button']": {
      cursor: "pointer",
    },
    "&[role='button']:hover": {
      transform: "translateY(-1px)",
      boxShadow: "0 8px 20px rgba(15,23,42,0.08)",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "8px 10px",
      gap: 8,
    },
  },
  kpiIcon: {
    width: 34,
    height: 34,
    borderRadius: 10,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    backgroundColor: theme.mode === "dark" ? "rgba(99,102,241,0.2)" : "#eef2ff",
    color: theme.palette.primary.main,
    "& .MuiSvgIcon-root": { fontSize: 18 },
  },
  kpiToneGood: {
    backgroundColor: theme.mode === "dark" ? "rgba(46,125,50,0.2)" : "#ecfdf3",
    color: "#2e7d32",
  },
  kpiToneWarn: {
    backgroundColor: theme.mode === "dark" ? "rgba(237,108,2,0.2)" : "#fff7ed",
    color: "#c2410c",
  },
  kpiToneBad: {
    backgroundColor: theme.mode === "dark" ? "rgba(198,40,40,0.2)" : "#fef2f2",
    color: "#c62828",
  },
  kpiBody: {
    minWidth: 0,
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  kpiValue: {
    fontSize: "1.05rem",
    fontWeight: 800,
    lineHeight: 1.2,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.95rem",
    },
  },
  kpiLabel: {
    fontSize: 11,
    fontWeight: 700,
    color: theme.palette.text.secondary,
    marginTop: 0,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  kpiHint: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    marginTop: 8,
  },
  kpiDelta: {
    fontSize: 11,
    fontWeight: 700,
    marginTop: 2,
  },
  kpiDeltaUp: { color: "#2e7d32" },
  kpiDeltaDown: { color: "#c62828" },
  summaryStrip: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  summaryItem: {
    padding: theme.spacing(2),
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  summaryValueIncome: { fontWeight: 700, color: "#2e7d32" },
  summaryValueCost: { fontWeight: 700, color: "#c62828" },
  summaryValueProfit: { fontWeight: 700, color: theme.palette.primary.main },
  alertRow: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
  },
  alertBanner: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
    cursor: "pointer",
    backgroundColor: theme.palette.background.paper,
  },
  alertExpired: {
    borderColor: theme.mode === "dark" ? "rgba(198,40,40,0.45)" : "#fecaca",
    backgroundColor: theme.mode === "dark" ? "rgba(198,40,40,0.12)" : "#fef2f2",
  },
  alertExpiring: {
    borderColor: theme.mode === "dark" ? "rgba(237,108,2,0.45)" : "#fed7aa",
    backgroundColor: theme.mode === "dark" ? "rgba(237,108,2,0.12)" : "#fff7ed",
  },
  alertPending: {
    borderColor: theme.mode === "dark" ? "rgba(21,101,192,0.45)" : "#bfdbfe",
    backgroundColor: theme.mode === "dark" ? "rgba(21,101,192,0.12)" : "#eff6ff",
  },
  alertTitle: { fontWeight: 700, fontSize: 14 },
  alertSub: { fontSize: 12, color: theme.palette.text.secondary, marginTop: 2 },
  dashSplit: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1.7fr) minmax(280px, 1fr)",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
    },
  },
  dashPanel: {
    padding: theme.spacing(2),
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    minHeight: 320,
    [theme.breakpoints.down("sm")]: {
      minHeight: 220,
      padding: theme.spacing(1.5),
    },
  },
  chartMeta: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(2),
    margin: theme.spacing(1, 0, 2),
  },
  chartMetaItem: {
    minWidth: 120,
  },
  chartMetaLabel: {
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    color: theme.palette.text.secondary,
  },
  serviceRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(1.25),
  },
  serviceName: {
    width: 140,
    flexShrink: 1,
    minWidth: 72,
    maxWidth: 180,
    fontSize: 13,
    fontWeight: 600,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    [theme.breakpoints.down("sm")]: {
      width: 92,
      maxWidth: 110,
      fontSize: 12,
    },
  },
  serviceTrack: {
    flex: 1,
    height: 8,
    borderRadius: 999,
    backgroundColor: theme.mode === "dark" ? "rgba(148,163,184,0.24)" : "#e2e8f0",
    overflow: "hidden",
  },
  serviceFill: {
    height: "100%",
    borderRadius: 999,
    backgroundColor: theme.palette.primary.main,
    transition: "width 0.8s cubic-bezier(0.22, 1, 0.36, 1)",
  },
  serviceAmount: {
    minWidth: 72,
    width: "auto",
    textAlign: "right",
    fontSize: 12,
    color: theme.palette.text.secondary,
    flexShrink: 0,
    whiteSpace: "nowrap",
    [theme.breakpoints.down("sm")]: {
      fontSize: 11,
      minWidth: 64,
    },
  },
  customerCode: {
    display: "inline-flex",
    alignItems: "center",
    padding: "3px 8px",
    borderRadius: 8,
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: "0.04em",
    fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
    color: theme.palette.primary.main,
    backgroundColor: theme.mode === "dark" ? "rgba(14,165,233,0.16)" : "#e0f2fe",
  },
  codeFinal: {
    color: "#0d47a1",
    backgroundColor: theme.mode === "dark" ? "rgba(21,101,192,0.2)" : "#e3f2fd",
  },
  codeReseller: {
    color: "#6a1b9a",
    backgroundColor: theme.mode === "dark" ? "rgba(123,31,162,0.22)" : "#f3e5f5",
  },
  typeMark: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 32,
    height: 32,
    padding: 0,
    borderRadius: 999,
    flexShrink: 0,
    "& svg": { fontSize: 18 },
  },
  typeFinal: {
    color: "#0d47a1",
    backgroundColor: theme.mode === "dark" ? "rgba(21,101,192,0.18)" : "#e3f2fd",
  },
  typeReseller: {
    color: "#6a1b9a",
    backgroundColor: theme.mode === "dark" ? "rgba(123,31,162,0.22)" : "#f3e5f5",
  },
  metricCell: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    fontWeight: 700,
    minWidth: 0,
    "& svg": {
      flexShrink: 0,
    },
  },
  colHead: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    fontWeight: 800,
    "& svg": {
      fontSize: 16,
      opacity: 0.8,
    },
  },
  metricMuted: {
    color: theme.palette.text.secondary,
    fontWeight: 600,
  },
  metricClick: {
    cursor: "pointer",
    borderRadius: 8,
    padding: "2px 4px",
    margin: "-2px -4px",
    "&:hover": {
      backgroundColor: theme.mode === "dark" ? "rgba(249,168,37,0.12)" : "#fff8e1",
    },
  },
  metricPoints: { color: "#f9a825" },
  metricServices: { color: "#00897b" },
  metricMoney: { color: "#2e7d32" },
  metricTelegram: { color: "#0088cc" },
  detailStats: {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    margin: theme.spacing(1, 0),
    minWidth: 0,
    [theme.breakpoints.down("sm")]: {
      flexWrap: "nowrap",
      overflowX: "auto",
      overflowY: "hidden",
      WebkitOverflowScrolling: "touch",
      margin: theme.spacing(1, 0),
      ...theme.hiddenScrollbar,
    },
  },
  detailStat: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "4px 10px 4px 6px",
    borderRadius: 999,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.mode === "dark" ? "rgba(15,23,42,0.35)" : "#f8fafc",
    minWidth: 0,
    flex: "0 1 auto",
    "& .MuiIconButton-root": { padding: 2, width: 24, height: 24 },
    "& .MuiSvgIcon-root": { fontSize: 16 },
    [theme.breakpoints.down("sm")]: {
      flex: "0 0 auto",
      padding: "4px 10px 4px 4px",
    },
  },
  detailStatHead: {
    display: "inline-flex",
    alignItems: "center",
    gap: 2,
  },
  detailStatIcon: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 22,
    height: 22,
    color: theme.palette.text.secondary,
  },
  detailStatValue: {
    fontSize: 13,
    fontWeight: 800,
    lineHeight: 1.2,
    whiteSpace: "nowrap",
  },
  detailStatLabel: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    marginTop: 2,
    [theme.breakpoints.down("sm")]: {
      fontSize: 10.5,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
  detailActions: {
    maxWidth: "100%",
    minWidth: 0,
    flexWrap: "nowrap",
    overflowX: "auto",
    whiteSpace: "nowrap",
    ...theme.hiddenScrollbar,
    "& > *": { flexShrink: 0 },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  detailMeta: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  trafficDot: {
    width: 12,
    height: 12,
    borderRadius: "50%",
    display: "inline-block",
    flexShrink: 0,
    boxShadow: "0 0 0 3px rgba(0,0,0,0.06)",
  },
  cardHead: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 10,
    minWidth: 0,
  },
  cardBadges: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    flexShrink: 0,
  },
  contactLine: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    flexWrap: "wrap",
    fontSize: 13,
    color: theme.palette.text.secondary,
    minWidth: 0,
  },
  detailTop: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
  },
  sectionTitle: {
    fontSize: 13,
    fontWeight: 800,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    color: theme.palette.text.secondary,
    margin: theme.spacing(1, 0, 1.5),
  },
  setupGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
  },
  setupCard: {
    padding: theme.spacing(2),
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    minHeight: 148,
    display: "flex",
    flexDirection: "column",
    cursor: "pointer",
  },
  setupInstructions: {
    fontSize: 13, lineHeight: 1.6, marginBottom: theme.spacing(1.5),
    "& summary": { cursor: "pointer", color: theme.palette.primary.main, fontWeight: 600 },
    "& ol": { paddingLeft: 22, marginBottom: 0 },
    "& li": { marginBottom: 8 },
  },
  setupCardDone: {
    borderColor: "#86efac",
    backgroundColor: theme.mode === "dark" ? "rgba(22,163,74,0.12)" : "#f0fdf4",
  },
  imapGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2.5),
  },
  imapCard: {
    padding: 0,
    borderRadius: 18,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.mode === "dark" ? "0 10px 28px rgba(0,0,0,0.18)" : "0 10px 28px rgba(37,99,235,0.08)",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
  },
  imapCardOk: {
    borderColor: theme.mode === "dark" ? "rgba(34,197,94,0.45)" : "#86efac",
  },
  imapCardErr: {
    borderColor: theme.mode === "dark" ? "rgba(198,40,40,0.45)" : "#fecaca",
  },
  imapCardHead: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 12,
    padding: "16px 18px 12px",
    background: theme.mode === "dark"
      ? "linear-gradient(180deg, rgba(37,99,235,0.16), transparent)"
      : "linear-gradient(180deg, #eff6ff, #ffffff)",
  },
  imapCardIdentity: {
    display: "flex",
    alignItems: "flex-start",
    gap: 12,
    minWidth: 0,
  },
  imapCardIcon: {
    width: 40,
    height: 40,
    borderRadius: 12,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.mode === "dark" ? "rgba(37,99,235,0.22)" : "#dbeafe",
    color: theme.palette.primary.main,
    flexShrink: 0,
    "& svg": { fontSize: 22 },
  },
  imapCardTitle: {
    fontSize: 16,
    fontWeight: 800,
    lineHeight: 1.2,
  },
  imapCardEmail: {
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.text.secondary,
    marginTop: 2,
    wordBreak: "break-all",
  },
  imapCardToggle: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    flexShrink: 0,
  },
  imapCardBody: {
    padding: "4px 18px 16px",
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  imapHostRow: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) 112px",
    gap: 10,
  },
  imapChipOk: {
    height: 22,
    fontSize: 11,
    fontWeight: 800,
    backgroundColor: theme.mode === "dark" ? "rgba(34,197,94,0.18)" : "#dcfce7",
    color: "#15803d",
  },
  imapHint: {
    display: "flex",
    alignItems: "flex-start",
    gap: 6,
    fontSize: 12,
    color: theme.palette.text.secondary,
    lineHeight: 1.4,
    margin: "4px 0 8px",
    "& svg": { fontSize: 16, marginTop: 1, flexShrink: 0 },
  },
  imapFooter: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginTop: 8,
    flexWrap: "wrap",
  },
  imapTestBtn: {
    fontWeight: 800,
    letterSpacing: 0.2,
    borderRadius: 12,
    textTransform: "none",
  },
  imapDetails: {
    fontSize: 12,
    lineHeight: 1.45,
    color: theme.palette.text.secondary,
    backgroundColor: theme.mode === "dark" ? "rgba(15,23,42,0.35)" : "#f8fafc",
    borderRadius: 10,
    padding: "8px 10px",
    marginTop: 8,
    whiteSpace: "pre-wrap",
  },
  imapOperatorCard: {
    padding: theme.spacing(2),
    borderRadius: 18,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.mode === "dark" ? "0 8px 20px rgba(0,0,0,0.14)" : "0 8px 20px rgba(15,23,42,0.05)",
  },
  setupStep: {
    fontSize: 12,
    fontWeight: 800,
    color: theme.palette.primary.main,
    marginBottom: 6,
  },
  setupTitle: { fontSize: 16, fontWeight: 700, marginBottom: 6 },
  setupDesc: {
    fontSize: 13,
    color: theme.palette.text.secondary,
    flex: 1,
    marginBottom: theme.spacing(1.5),
  },
  tableWrap: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 12,
    overflow: "auto",
    maxHeight: "calc(100dvh - 248px)",
    backgroundColor: theme.palette.background.paper,
    WebkitOverflowScrolling: "touch",
    "& table": {
      minWidth: 720,
    },
    "& thead th": {
      position: "sticky",
      top: 0,
      zIndex: 5,
      backgroundColor: theme.palette.background.paper,
      boxShadow: `inset 0 -1px 0 ${theme.palette.divider}`,
      whiteSpace: "nowrap",
    },
    "& thead th:last-child": {
      right: 0,
      zIndex: 6,
    },
    [theme.breakpoints.down("sm")]: {
      borderRadius: 10,
      maxHeight: "calc(100dvh - 188px)",
      "& table": {
        minWidth: 0,
      },
      "& thead th:last-child, & tbody td:last-child": {
        position: "static",
        right: "auto",
        boxShadow: "none",
      },
    },
  },
  clickableRow: {
    cursor: "pointer",
  },
  stickyActions: {
    position: "sticky",
    right: 0,
    backgroundColor: theme.palette.background.paper,
    whiteSpace: "nowrap",
    minWidth: 108,
    zIndex: 2,
    boxShadow: theme.mode === "dark" ? "-8px 0 12px rgba(0,0,0,0.25)" : "-8px 0 12px rgba(15,23,42,0.06)",
    [theme.breakpoints.down("sm")]: {
      position: "static",
      boxShadow: "none",
      minWidth: 0,
    },
  },
  actionCluster: {
    display: "inline-flex",
    alignItems: "center",
    gap: 2,
    whiteSpace: "nowrap",
    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
      maxWidth: "100%",
      whiteSpace: "normal",
    },
  },
  cartTitleBar: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 8,
    margin: "-4px 0 4px",
    minWidth: 0,
    maxWidth: "100%",
  },
  cartPaper: {
    display: "flex",
    flexDirection: "column",
    maxHeight: "92vh",
    [theme.breakpoints.down("sm")]: {
      maxHeight: "100%",
      margin: 0,
      width: "100%",
      maxWidth: "100%",
      borderRadius: 0,
    },
  },
  cartRecords: {
    paddingTop: 8,
    flex: "1 1 auto",
    minHeight: 220,
    maxHeight: "min(64vh, 620px)",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    [theme.breakpoints.down("sm")]: {
      maxHeight: "none",
      minHeight: 0,
    },
  },
  serviceAccountCell: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    minWidth: 0,
    maxWidth: 280,
  },
  serviceAccountEmail: {
    fontWeight: 700,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    minWidth: 0,
  },
  optionRow: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    minWidth: 0,
  },
  relatedLinks: {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    marginTop: theme.spacing(1.5),
  },
  infoField: {
    marginBottom: theme.spacing(1.25),
  },
  contactAvatar: {
    fontWeight: 800,
    fontSize: 13,
    flexShrink: 0,
  },
  agendaCell: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    minWidth: 0,
  },
  agendaBody: {
    minWidth: 0,
  },
  profileStack: {
    display: "flex",
    flexDirection: "column",
    gap: 6,
    minWidth: 220,
  },
  profileChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "4px 8px",
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 700,
    border: "1px solid transparent",
    maxWidth: "100%",
  },
  profileChipName: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: 110,
  },
  profileChipPin: {
    fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
    fontWeight: 700,
    opacity: 0.85,
  },
  chip: { fontWeight: 600 },
  emptyState: {
    textAlign: "left",
    padding: theme.spacing(1.25, 0.5),
    color: theme.palette.text.secondary,
  },
  loadingState: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    minHeight: 48,
    padding: theme.spacing(1.5, 0.5),
  },
  emptyTitle: {
    fontSize: 14,
    fontWeight: 700,
    color: theme.palette.text.primary,
    marginBottom: 2,
  },
  emptySubtitle: {
    fontSize: 13,
    maxWidth: 560,
    margin: 0,
    lineHeight: 1.4,
  },
  profileBox: {
    padding: theme.spacing(1.5, 2, 2),
    backgroundColor: theme.mode === "dark" ? "rgba(15,23,42,0.35)" : "#f8fafc",
  },
  captionBlock: {
    display: "block",
    color: theme.palette.text.secondary,
  },
  slotsHint: {
    fontWeight: 700,
  },
  productHead: {
    display: "flex",
    alignItems: "flex-start",
    gap: 12,
    minWidth: 0,
    [theme.breakpoints.down("sm")]: {
      gap: 8,
      alignItems: "center",
    },
  },
  productCover: {
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    textAlign: "center",
    padding: "0 16px 16px",
    overflow: "hidden",
  },
  productCoverBanner: {
    height: 78,
    margin: "0 -16px",
    background: theme.palette.barraSuperior || "#4F46F5",
  },
  productCoverLogoWrap: {
    width: 88,
    height: 88,
    borderRadius: "50%",
    backgroundColor: theme.palette.background.paper,
    margin: "-44px auto 12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: theme.mode === "dark"
      ? "0 8px 24px rgba(0,0,0,0.28)"
      : "0 8px 20px rgba(37,99,235,0.12)",
    overflow: "hidden",
  },
  productCoverName: {
    fontWeight: 800,
    fontSize: 18,
    color: theme.palette.text.primary,
    lineHeight: 1.2,
  },
  productCoverMeta: {
    marginTop: 4,
    fontSize: 12,
    fontWeight: 700,
    color: theme.palette.text.secondary,
  },
  productCoverDesc: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    margin: "8px 0 14px",
    lineHeight: 1.4,
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  },
  productCoverStats: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: 8,
    "& > div": {
      minWidth: 0,
    },
    "& strong": {
      display: "block",
      color: theme.palette.text.primary,
      fontSize: 22,
      fontWeight: 800,
      lineHeight: 1.1,
    },
    "& span": {
      fontSize: 11,
      color: theme.palette.text.secondary,
    },
  },
  productCard: {
    padding: "0 !important",
    overflow: "hidden",
    "& > div:last-child": {
      padding: "8px 12px 12px",
    },
  },
  heroTitle: {
    padding: "0 !important",
  },
  comboSlot: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 12,
    padding: 10,
    marginTop: 8,
  },
  productLogo: {
    width: 40,
    height: 40,
    borderRadius: 10,
    objectFit: "cover",
    flexShrink: 0,
    backgroundColor: theme.mode === "dark" ? "rgba(14,165,233,0.16)" : "#e0f2fe",
    color: theme.palette.primary.main,
    fontWeight: 800,
    fontSize: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  productLogoImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },
  logoDrop: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    border: `1px dashed ${theme.palette.divider}`,
    borderRadius: 12,
    padding: theme.spacing(2),
    textAlign: "center",
    cursor: "pointer",
    backgroundColor: theme.mode === "dark" ? "rgba(15,23,42,0.35)" : "#f8fafc",
  },
  productStats: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: 8,
    marginTop: 8,
  },
  productStatsLine: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "baseline",
    gap: "4px 10px",
    marginTop: 6,
    fontSize: 12,
    lineHeight: 1.3,
    color: theme.palette.text.secondary,
    "& strong": {
      color: theme.palette.text.primary,
      fontWeight: 800,
      fontSize: 13,
    },
  },
  productStatPrice: {
    marginLeft: "auto",
    color: theme.palette.text.primary,
    fontWeight: 800,
    fontSize: 14,
  },
  profileDots: {
    display: "flex",
    flexWrap: "wrap",
    gap: 10,
    alignItems: "flex-start",
  },
  profileGrid: {
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "flex-start",
    gap: 4,
    width: "max-content",
    maxWidth: "100%",
    overflowX: "auto",
    overflowY: "hidden",
    WebkitOverflowScrolling: "touch",
    ...theme.hiddenScrollbar,
  },
  profileGridFill: {
    width: "100%",
    minWidth: 0,
  },
  profileGridFillInner: {
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden",
  },
  profileDotsWrap: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 58px)",
    gap: "8px 10px",
    width: "max-content",
  },
  profileDotsFill: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(72px, 1fr))",
    gap: "10px 8px",
    width: "100%",
  },
  profileDotsCompact: {
    gap: 2,
  },
  profileSlotCompact: {
    width: 32,
    minHeight: 32,
    gap: 0,
  },
  profileMore: {
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 1,
    width: 36,
    minHeight: 40,
    flexShrink: 0,
    background: "none",
    border: `1px dashed ${theme.palette.divider}`,
    borderRadius: 10,
    cursor: "pointer",
    color: theme.palette.text.secondary,
    fontSize: 10,
    fontWeight: 800,
    padding: 2,
  },
  profileSlot: {
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 2,
    width: 42,
    flexShrink: 0,
    background: "none",
    border: 0,
    padding: 0,
  },
  profileSlotName: {
    fontSize: 9,
    fontWeight: 700,
    lineHeight: 1.1,
    textAlign: "center",
    maxWidth: 42,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  profileDot: {
    width: 26,
    height: 26,
    borderRadius: "50%",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid transparent",
    flexShrink: 0,
    overflow: "hidden",
    padding: 0,
  },
  profileDotClick: {
    cursor: "pointer",
  },
  profileDotFree: {
    color: "#2e7d32",
    backgroundColor: theme.mode === "dark" ? "rgba(46,125,50,0.2)" : "#e8f5e9",
    borderColor: "#81c784",
  },
  profileDotBusy: {
    color: "#c62828",
    backgroundColor: theme.mode === "dark" ? "rgba(198,40,40,0.2)" : "#ffebee",
    borderColor: "#e57373",
  },
  typePick: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 8,
    margin: "12px 0",
  },
  typeCard: {
    padding: theme.spacing(1.5),
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
    cursor: "pointer",
    backgroundColor: theme.palette.background.paper,
    textAlign: "left",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 4,
    font: "inherit",
    color: "inherit",
  },
  typeCardOn: {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.mode === "dark" ? "rgba(14,165,233,0.12)" : "#e0f2fe",
  },
  varRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 6,
    marginBottom: theme.spacing(1),
  },
  previewWrap: {
    borderRadius: 12,
    padding: theme.spacing(2),
    minHeight: 120,
    backgroundColor: theme.mode === "dark" ? "#0f172a" : "#ece5dd",
    backgroundImage: theme.mode === "dark"
      ? "none"
      : "radial-gradient(rgba(0,0,0,0.04) 1px, transparent 1px)",
    backgroundSize: "14px 14px",
  },
  previewBubble: {
    maxWidth: "86%",
    marginLeft: "auto",
    padding: "8px 12px",
    borderRadius: "12px 4px 12px 12px",
    backgroundColor: theme.mode === "dark" ? "#1e3a2f" : "#d9fdd3",
    color: theme.mode === "dark" ? "#f8fafc" : "#111827",
    fontSize: 14,
    lineHeight: 1.45,
    boxShadow: "0 1px 2px rgba(0,0,0,0.12)",
    wordBreak: "break-word",
    "& .wa-mono": {
      display: "block",
      fontFamily: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
      fontSize: 12.5,
      backgroundColor: "rgba(0,0,0,0.06)",
      borderRadius: 6,
      padding: "6px 8px",
      margin: "4px 0",
      whiteSpace: "pre-wrap",
    },
    "& .wa-quote": {
      display: "block",
      borderLeft: "3px solid rgba(0,0,0,0.28)",
      padding: "2px 0 2px 8px",
      margin: "4px 0",
      opacity: 0.92,
    },
  },
  previewMedia: {
    width: "100%",
    maxHeight: 180,
    objectFit: "cover",
    borderRadius: 8,
    marginBottom: 8,
    display: "block",
  },
  settingsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: theme.spacing(1.5),
    alignItems: "start",
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "minmax(0, 1fr) 88px",
      gap: theme.spacing(1),
    },
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr",
    },
  },
  accordionCard: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 12,
    marginBottom: theme.spacing(1.5),
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
  },
  liveStatus: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    fontWeight: 800,
    fontSize: 12,
    whiteSpace: "nowrap",
    "& svg": {
      flexShrink: 0,
    },
  },
  accountPassword: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    marginTop: 2,
    fontSize: 12,
    fontWeight: 700,
    color: theme.palette.text.secondary,
    wordBreak: "break-all",
  },
  accountMiniStats: {
    display: "flex",
    flexWrap: "wrap",
    gap: "4px 12px",
    marginTop: 4,
    fontSize: 11,
    fontWeight: 700,
    color: theme.palette.text.secondary,
    "& span": {
      display: "inline-flex",
      alignItems: "center",
      gap: 3,
    },
  },
  accountPeekTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    fontWeight: 800,
    fontSize: 18,
    "& > :first-child": { minWidth: 0 },
    "& > :last-child": { flexShrink: 0 },
  },
  accountHero: {
    position: "relative",
    overflow: "hidden",
    borderRadius: 18,
    padding: 16,
    marginBottom: 12,
    color: theme.mode === "dark" ? "#eef2ff" : "#312e81",
    background: theme.mode === "dark"
      ? "linear-gradient(135deg, #4338ca 0%, #6366f1 52%, #8b5cf6 100%)"
      : "linear-gradient(135deg, #eef2ff 0%, #e0e7ff 48%, #ede9fe 100%)",
    animation: "$accountHeroGlow 3.2s ease-in-out infinite",
    "&::after": {
      content: '""',
      position: "absolute",
      top: -40,
      right: -30,
      width: 140,
      height: 140,
      borderRadius: "50%",
      background: "radial-gradient(circle, rgba(165,180,252,0.45), transparent 68%)",
      pointerEvents: "none",
    },
  },
  accountHeroTop: {
    display: "flex",
    alignItems: "center",
    gap: 14,
    position: "relative",
    zIndex: 1,
  },
  accountHeroLogoWrap: {
    position: "relative",
    width: 56,
    height: 56,
    flexShrink: 0,
  },
  accountHeroRing: {
    position: "absolute",
    inset: -8,
    width: 72,
    height: 72,
    transform: "rotate(-90deg)",
    pointerEvents: "none",
  },
  accountHeroRingTrack: {
    fill: "none",
    stroke: theme.mode === "dark" ? "rgba(255,255,255,0.18)" : "rgba(79,70,229,0.18)",
    strokeWidth: 4,
  },
  accountHeroRingFill: {
    fill: "none",
    stroke: theme.mode === "dark" ? "#c4b5fd" : "#6366f1",
    strokeWidth: 4,
    strokeLinecap: "round",
    transition: "stroke-dashoffset 1.1s cubic-bezier(0.22, 1, 0.36, 1)",
    filter: "drop-shadow(0 0 6px rgba(99,102,241,0.35))",
  },
  accountHeroName: {
    fontWeight: 800,
    fontSize: 18,
    lineHeight: 1.2,
  },
  accountHeroEmail: {
    marginTop: 2,
    fontSize: 13,
    opacity: 0.9,
    wordBreak: "break-all",
  },
  accountHeroPass: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    marginTop: 4,
    fontSize: 13,
    fontWeight: 700,
    color: theme.mode === "dark" ? "#c4b5fd" : "#4f46e5",
    wordBreak: "break-all",
  },
  accountHeroCode: {
    display: "inline-flex",
    marginTop: 6,
    padding: "2px 8px",
    borderRadius: 999,
    background: theme.mode === "dark" ? "rgba(255,255,255,0.12)" : "rgba(79,70,229,0.12)",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 0.4,
  },
  accountHeroDays: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    marginTop: 14,
    fontWeight: 800,
    fontSize: 14,
    color: theme.mode === "dark" ? "#fbcfe8" : "#7c3aed",
    position: "relative",
    zIndex: 1,
  },
  accountHeroBar: {
    display: "flex",
    height: 10,
    borderRadius: 999,
    overflow: "hidden",
    marginTop: 8,
    background: "linear-gradient(90deg, #c4b5fd, #a78bfa)",
    position: "relative",
    zIndex: 1,
  },
  accountHeroBarFill: {
    height: "100%",
    background: "linear-gradient(90deg, #818cf8, #6366f1)",
    borderRadius: "999px 0 0 999px",
    transition: "width 1.1s cubic-bezier(0.22, 1, 0.36, 1)",
    boxShadow: "0 0 14px rgba(99,102,241,0.35)",
  },
  accountHeroStats: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: 8,
    marginTop: 14,
    position: "relative",
    zIndex: 1,
  },
  accountHeroStat: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 2,
    padding: "8px 6px",
    borderRadius: 12,
    background: theme.mode === "dark" ? "rgba(255,255,255,0.12)" : "rgba(255,255,255,0.55)",
    animation: "$accountStatIn 0.55s ease both",
    "& strong": {
      fontSize: 18,
      lineHeight: 1.1,
    },
    "& span": {
      fontSize: 10,
      fontWeight: 700,
      letterSpacing: 0.4,
      textTransform: "uppercase",
      opacity: 0.8,
    },
  },
  accountSaleRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "8px 6px",
    borderRadius: 12,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.mode === "dark" ? "rgba(255,255,255,0.06)" : "#f8fafc",
    },
  },
  accountSaleName: {
    fontWeight: 800,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  "@keyframes accountHeroGlow": {
    "0%, 100%": { boxShadow: "0 8px 22px rgba(99,102,241,0.16)" },
    "50%": { boxShadow: "0 12px 28px rgba(139,92,246,0.26)" },
  },
  "@keyframes accountStatIn": {
    from: { opacity: 0, transform: "translateY(8px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
}));
